import CvSectionTemplate from './CvSectionTemplate';

export default function CvProfessionalSummary() {
  return (
    <CvSectionTemplate
      currentId="check_1"
      title="Podsumowanie zawodowe"
      description="Napisz krótkie streszczenie swoich doświadczeń zawodowych, celów i mocnych stron."
    />
  );
}
